module.exports = __webpack_public_path__ + "static/media/MomentosBravectoCard2.1cbf6d9d.webp";